<template>
  <div class="page-wrap">
    <!-- 顶部筛选区域 -->
    <div class="search-card">
      <el-row :gutter="18">
        <el-col span="4">
          <el-form-item label="统计时段">
            <el-date-picker
              v-model="search.timeRange"
              type="datetimerange"
              range-separator="~"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col span="3">
          <el-form-item label="所属车间">
            <el-select v-model="search.workshop" clearable placeholder="全部">
              <el-option label="一车间" value="work1" />
              <el-option label="二车间" value="work2" />
              <el-option label="储罐区" value="tankArea" />
              <el-option label="废气处理区" value="gasArea" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="3">
          <el-form-item label="泄漏气体类型">
            <el-select v-model="search.gasType" clearable placeholder="全部">
              <el-option label="甲烷" value="methane" />
              <el-option label="非甲烷总烃VOC" value="nmhc" />
              <el-option label="苯系物" value="benzene" />
              <el-option label="二甲苯" value="xylene" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="3">
          <el-form-item label="风险等级">
            <el-select v-model="search.riskLevel" clearable placeholder="全部">
              <el-option label="一级重大(红)" value="1" />
              <el-option label="二级较大(橙)" value="2" />
              <el-option label="三级一般(黄)" value="3" />
              <el-option label="四级低(蓝)" value="4" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="3">
          <el-form-item label="整改状态">
            <el-select v-model="search.fixStatus" clearable placeholder="全部">
              <el-option label="未整改" value="0" />
              <el-option label="整改中" value="1" />
              <el-option label="已闭环" value="2" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="3">
          <el-form-item label="管控责任人">
            <el-input v-model="search.dutyUser" placeholder="输入姓名" />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="btn-group">
        <el-button type="primary" class="btn-main" @click="queryData"
          >查询</el-button
        >
        <el-button @click="resetSearch">重置筛选</el-button>
        <el-button type="warning" @click="exportReport"
          >导出完整风险报表(PDF+Excel)</el-button
        >
      </div>
    </div>

    <!-- 图表双栏区域 -->
    <div class="chart-row">
      <div class="chart-card">
        <div class="chart-title">气体泄漏风险等级数量统计</div>
        <div ref="barChartRef" class="echart-box"></div>
      </div>
      <div class="chart-card">
        <div class="chart-title">各类泄漏风险占比分布</div>
        <div ref="pieChartRef" class="echart-box"></div>
      </div>
    </div>

    <!-- 厂区风险点位地图 -->
    <!-- <div class="map-card">
      <div class="map-title">
        厂区气体泄漏风险点位分布图
        <span class="map-legend">
          <span class="leg dot r"></span>一级重大
          <span class="leg dot o"></span>二级较大
          <span class="leg dot y"></span>三级一般
          <span class="leg dot b"></span>四级低风险
        </span>
      </div>
      <div class="factory-map">
        <div class="map-bg"></div>

        <div
          v-for="p in riskPointList"
          :key="p.id"
          class="risk-point"
          :class="p.levelClass"
          :style="{ left: p.x + '%', top: p.y + '%' }"
          @mouseenter="showPointTip($event, p)"
          @mouseleave="hidePointTip"
          @click="openDetail(p)"
        ></div>

        <div v-if="tipShow" class="point-tip" :style="tipStyle">
          <p>{{ pTip.name }}</p>
          <p>气体：{{ pTip.gas }}</p>
          <p>风险等级：{{ pTip.levelText }}</p>
          <p>整改状态：{{ pTip.fixText }}</p>
        </div>
      </div>
    </div> -->

    <!-- 风险完整清单表格 -->
    <div class="table-card">
      <div class="table-title">
        气体泄漏风险辨识全量清单（不可删除，永久留存）
      </div>
      <el-table
        :data="riskTableData"
        border
        height="300"
        class="data-table"
        :row-class-name="getTableRowClass"
      >
        <el-table-column label="风险编号" prop="riskNo" width="110" />
        <el-table-column label="风险位置" prop="location" min-width="130" />
        <el-table-column label="泄漏介质" prop="gasName" width="110" />
        <el-table-column label="风险等级" prop="level" width="100">
          <template #default="scope">
            <el-tag :type="getTag(scope.row.level)">{{
              getLevelText(scope.row.level)
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="泄漏诱因" prop="cause" min-width="160" />
        <el-table-column label="事故后果" prop="result" min-width="160" />
        <el-table-column label="现有管控措施" prop="measure" min-width="180" />
        <el-table-column label="管控责任人" prop="dutyUser" width="100" />
        <el-table-column label="整改状态" prop="fixStatus" width="100">
          <template #default="scope">
            <el-tag :type="getFixTag(scope.row.fixStatus)">{{
              getFixText(scope.row.fixStatus)
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="上次排查时间" prop="checkTime" width="160" />
        <el-table-column label="操作" fixed="right" width="300">
          <template #default="scope">
            <el-button size="small" @click="openDetail(scope.row)"
              >风险详情</el-button
            >
            <el-button size="small" type="info" @click="singleExport(scope.row)"
              >单条导出</el-button
            >
            <el-button
              size="small"
              type="warning"
              v-if="scope.row.fixStatus !== 2"
              @click="startFix(scope.row)"
              >发起整改</el-button
            >
            <el-button
              size="small"
              type="success"
              v-if="scope.row.fixStatus === 1"
              @click="closeFix(scope.row)"
              >标记闭环</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 风险详情弹窗 -->
    <el-dialog
      v-model="detailVisible"
      title="气体泄漏风险完整详情(HAZOP辨识记录)"
      width="90%"
      class="dark-dialog"
      top="10px"
    >
      <div class="detail-wrap" v-if="currRisk">
        <!-- 基础信息 -->
        <div class="info-block">
          <div class="block-title">基础风险信息</div>
          <div class="info-grid">
            <div class="info-item">
              <label>风险编号：</label>{{ currRisk.riskNo }}
            </div>
            <div class="info-item">
              <label>所在区域：</label>{{ currRisk.location }}
            </div>
            <div class="info-item">
              <label>泄漏气体：</label>{{ currRisk.gasName }}
            </div>
            <div class="info-item">
              <label>风险等级：</label
              ><el-tag :type="getTag(currRisk.level)">{{
                getLevelText(currRisk.level)
              }}</el-tag>
            </div>
            <div class="info-item">
              <label>管控人：</label>{{ currRisk.dutyUser }}
            </div>
            <div class="info-item">
              <label>整改状态：</label
              ><el-tag :type="getFixTag(currRisk.fixStatus)">{{
                getFixText(currRisk.fixStatus)
              }}</el-tag>
            </div>
          </div>
        </div>
        <!-- HAZOP分析 -->
        <div class="info-block">
          <div class="block-title">HAZOP泄漏分析</div>
          <div class="info-long">
            <p><label>泄漏诱因：</label>{{ currRisk.cause }}</p>
            <p><label>可能事故后果：</label>{{ currRisk.result }}</p>
            <p><label>现有防控措施：</label>{{ currRisk.measure }}</p>
            <p><label>建议整改方案：</label>{{ currRisk.suggest }}</p>
          </div>
        </div>
        <!-- 整改跟踪记录 -->
        <div class="log-block">
          <div class="block-title">整改跟踪记录</div>
          <el-table :data="fixLogList" border height="200" class="data-table">
            <el-table-column label="操作时间" prop="time" width="160" />
            <el-table-column label="操作人" prop="user" width="100" />
            <el-table-column label="操作类型" prop="type" width="100" />
            <el-table-column label="整改内容" min-width="200" />
            <el-table-column label="佐证附件" prop="imgList" />
          </el-table>
        </div>
      </div>
      <template #footer>
        <el-button @click="detailVisible = false">关闭</el-button>
        <el-button type="primary" @click="singleExport(currRisk)"
          >导出本条风险台账</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="js">
import {ref,reactive,onMounted,onUnmounted,nextTick} from 'vue'
import {ElMessage,ElMessageBox} from 'element-plus'
import * as echarts from 'echarts'

// 分页
const pageNum = ref(1)
const tableTotal = ref(96)
// 筛选条件
const search = reactive({
  timeRange:[],workshop:'',gasType:'',riskLevel:'',fixStatus:'',dutyUser:''
})
// 图表DOM
const barChartRef = ref(null)
const pieChartRef = ref(null)
let barChart = null
let pieChart = null

// 地图点位悬浮
const tipShow = ref(false)
const tipStyle = reactive({left:'0px',top:'0px'})
const pTip = ref({})
// 厂区风险点位模拟
const riskPointList = ref([
  {id:1,x:16,y:24,level:'1',levelClass:'r',name:'4#装置甲烷泄漏点',gas:'甲烷',levelText:'一级重大',fixText:'未整改'},
  {id:2,x:34,y:42,level:'2',levelClass:'o',name:'废气出口VOC探头',gas:'VOC',levelText:'二级较大',fixText:'整改中'},
  {id:3,y:19,x:58,level:'1',levelClass:'r',name:'储罐区二甲苯阀门',gas:'二甲苯',levelText:'一级重大',fixText:'未整改'},
  {id:4,x:72,y:46,level:'3',levelClass:'y',name:'车间苯监测点位',gas:'苯',levelText:'三级一般',fixText:'已闭环'},
  {id:5,x:26,y:70,level:'4',levelClass:'b',name:'风机管道微量泄漏',gas:'甲烷',levelText:'四级低',fixText:'已闭环'},
  {id:6,x:79,y:32,level:'2',levelClass:'o',name:'尾气处理VOC排放口',gas:'VOC',levelText:'二级较大',fixText:'整改中'},
])

// 风险表格数据
const riskTableData = ref([
  {
    riskNo:'RISK20260729001',location:'4#装置上段管线',gasName:'甲烷',level:'1',
    cause:'法兰密封垫老化，高温腐蚀造成微量持续泄漏',
    result:'浓度超标引发火灾、人员中毒窒息',
    measure:'在线GDS监测、每日巡检、防爆风机',
    dutyUser:'张运维',fixStatus:'0',checkTime:'2026-07-28 09:30',
    suggest:'更换耐高温四氟密封垫，增加巡检频次至每日2次'
  },
  {
    riskNo:'RISK20260729002',location:'废气处理出口',gasName:'非甲烷总烃',level:'2',
    cause:'活性炭吸附层饱和，尾气超标泄漏',
    result:'环保处罚、厂区异味扩散',
    measure:'VOC在线监测、每周更换炭层',
    dutyUser:'李工',fixStatus:'1',checkTime:'2026-07-26 15:10',
    suggest:'缩短活性炭更换周期至5天，增设压差监测'
  },
  {
    riskNo:'RISK20260729003',location:'储罐区2#罐阀门',gasName:'二甲苯',level:'1',
    cause:'阀门填料老化，夜间低温渗漏',
    result:'有毒蒸汽积聚，爆炸风险',
    measure:'液位+气体双监测、围堰收集',
    dutyUser:'王主管',fixStatus:'0',checkTime:'2026-07-25 11:20',
    suggest:'更换填料，加装密闭收集管道'
  },
  {
    riskNo:'RISK20260729004',location:'一车间尾气管道',gasName:'苯',level:'3',
    cause:'焊缝轻微渗透，浓度低风险小',
    result:'长期慢性人员伤害',
    measure:'月度探伤、通风扇',
    dutyUser:'刘巡检',fixStatus:'2',checkTime:'2026-07-20 14:00',
    suggest:'焊缝补焊，每季度探伤复查'
  }
])

// 弹窗变量
const detailVisible = ref(false)
const currRisk = ref(null)
const fixLogList = ref([
  {time:'2026-07-28 10:00',user:'张运维',type:'发起整改',content:'法兰垫老化泄漏，申请备件更换',imgList:[]},
  {time:'2026-07-29 16:30',user:'王主管',type:'整改完成',content:'密封垫更换完毕，复测浓度正常',imgList:['/static/fix1.jpg']}
])

// 等级文字与标签
const getLevelText = val=>{
  const map={'1':'一级重大','2':'二级较大','3':'三级一般','4':'四级低风险'}
  return map[val]
}
const getTag = val=>{
  const map={'1':'danger','2':'warning','3':'success','4':'info'}
  return map[val]
}
const getFixText = val=>{
  const map={'0':'未整改','1':'整改中','2':'已闭环'}
  return map[val]
}
const getFixTag = val=>{
  const map={'0':'danger','1':'warning','2':'success'}
  return map[val]
}
// 表格行颜色区分
const getTableRowClass = ({row})=>{
  if(row.level==='1') return 'row-danger'
  if(row.level==='2') return 'row-warning'
  if(row.level==='3') return 'row-success'
  return ''
}

// 图表初始化
const initBarChart = async()=>{
  await nextTick()
  if(!barChartRef.value) return
  barChart = echarts.init(barChartRef.value,'dark')
  const opt = {
    tooltip:{trigger:'axis'},
    grid:{left:30,right:20,top:30,bottom:30},
    xAxis:{type:'category',data:['一级重大','二级较大','三级一般','四级低'],axisLine:{lineStyle:{color:'#2c3c58'}}},
    yAxis:{type:'value',splitLine:{lineStyle:{color:'#1a2b4f',type:'dashed'}}},
    series:[{
      type:'bar',barWidth:36,
      data:[12,28,36,20],
      itemStyle:{color:function(params){
        const colorList = ['#f56c6c','#e6a23c','#67c23a','#409eff']
        return colorList[params.dataIndex]
      }}
    }]
  }
  barChart.setOption(opt)
}
const initPieChart = async()=>{
  await nextTick()
  if(!pieChartRef.value) return
  pieChart = echarts.init(pieChartRef.value,'dark')
  const opt = {
    tooltip:{trigger:'item'},
    legend:{orient:'vertical',right:10,top:'center',textStyle:{color:'#a0b4d8'}},
    series:[{
      type:'pie',radius:['40%','70%'],center:['30%','50%'],
      data:[
        {value:32,name:'甲烷泄漏',itemStyle:{color:'#f56c6c'}},
        {value:28,name:'VOC非甲烷总烃',itemStyle:{color:'#e6a23c'}},
        {value:22,name:'苯系物',itemStyle:{color:'#67c23a'}},
        {value:14,name:'二甲苯',itemStyle:{color:'#409eff'}}
      ]
    }]
  }
  pieChart.setOption(opt)
}
const resizeChart = ()=>{
  barChart?.resize()
  pieChart?.resize()
}

// 地图点位悬浮
const showPointTip = (e,row)=>{
  tipShow.value = true
  tipStyle.left = e.clientX+12+'px'
  tipStyle.top = e.clientY+12+'px'
  pTip.value = row
}
const hidePointTip = ()=> tipShow.value = false

// 查询、重置
const queryData = ()=>{
  ElMessage.success('风险报表查询完成')
  pageNum.value=1
}
const resetSearch = ()=>{
  search.timeRange=[];search.work='';search.gasType='';search.riskLevel='';search.fixStatus='';search.dutyUser=''
}
// 导出
const exportReport = ()=> ElMessage.success('完整风险报表PDF+Excel导出成功')
const singleExport = row=> ElMessage.success(`${row.riskNo} 单条风险台账导出`)
// 整改操作
const startFix = row=> ElMessage.info(`已发起【${row.riskNo}】整改任务`)
const closeFix = row=>{
  ElMessageBox.confirm('确认该泄漏风险整改闭环？').then(()=>{
    row.fixStatus='2'
    ElMessage.success('已标记闭环，整改记录留存')
  })
}
// 打开详情
const openDetail = async(row)=>{
  currRisk.value = row
  detailVisible.value = true
}

onMounted(async()=>{
  await initBarChart()
  await initPieChart()
  window.addEventListener('resize',resizeChart)
})
onUnmounted(()=>{
  window.removeEventListener('resize',resizeChart)
  barChart?.dispose()
  pieChart?.dispose()
})
</script>

<style scoped>
.page-wrap {
  width: 100%;
  height: 100vh;
  padding: 20px;
  box-sizing: border-box;
  background: radial(
      circle at top left,
      rgba(64, 158, 255, 0.12),
      transparent 35%
    ),
    linear(135deg, #050b1f, #0a101f, #050b1f);
  color: var(--text-main);
}
/* 顶部筛选 */
.search-card {
  background: var(--bg-search);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
}
.search-card :deep(.el-form-item label) {
  color: var(--text-sub);
}
.btn-group {
  margin-top: 16px;
  display: flex;
  gap: 12px;
}
.btn-main {
  background: linear-gradient(90deg, #2196f3, #00d4ff);
  border: none;
}
/* 图表双栏 */
.chart-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}
.chart-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 320px;
}
.chart-title {
  font-size: 16;
  margin-bottom: 12;
  color: #d0f8ff;
}
.echart-box {
  flex: 1;
  width: 100%;
}
/* 厂区风险地图 */
.map-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}
.map-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  margin-bottom: 12px;
  color: #d0f8ff;
}
.map-legend {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: var(--text-sub);
}
.leg {
  display: flex;
  align-items: center;
  gap: 4px;
}
.dot {
  width: 10px;
  height: 10;
  border-radius: 50%;
}
.dot.r {
  background: var(--red);
  box-shadow: 0 0 6px var(--red);
}
.dot.o {
  background: var(--orange);
  box-shadow: 0 0 6px var(--orange);
}
.dot.y {
  background: var(--green);
  box-shadow: 0 0 6px var(--green);
}
.dot.b {
  background: var(--blue);
  box-shadow: 0 0 6px var(--blue);
}
.factory-map {
  width: 100%;
  height: 260px;
  position: relative;
  border: 1px solid rgba(64, 158, 0.18);
  border-radius: 6px;
  overflow: hidden;
}
.map-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: linear-gradient(130deg, #0e1629, #142240);
  background-image: repeating-linear-gradient(
    45deg,
    rgba(64, 158, 255, 0.06) 0,
    rgba(64, 158, 255, 0.06) 12px,
    transparent12px,
    transparent24px
  );
}
.risk-point {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  cursor: pointer;
  animation: pulse 1.8s infinite;
}
.r {
  background: var(--red);
  box-shadow: 0 0 0 4px rgba(245, 108, 108, 0.3);
}
.o {
  background: var(--orange);
  box-shadow: 0 0 0 4px rgba(230, 162, 60, 0.3);
}
.y {
  background: var(--green);
  box-shadow: 0 0 0 4px rgba(103, 194, 58, 0.3);
}
.b {
  background: var(--blue);
  box-shadow: 0 0 0 4px rgba(64, 158, 255, 0.3);
}
.point-tip {
  position: fixed;
  z-index: 999;
  background: rgba(10, 16, 31, 0.95);
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 10px;
  min-width: 180px;
  font-size: 13px;
  color: #d0f8ff;
}
.point-tip p {
  margin: 4px 0;
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(255, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 0.4);
  }
}
/* 表格区域 */
.table-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 8;
  padding: 16px;
}
.table-title {
  font-size: 16px;
  margin-bottom: 12px;
  color: #d0f8ff;
}

.dark-page :deep(.el-pagination) {
  color: var(--text-sub);
}
/* 弹窗样式 */
.dark-dialog :deep(.el-dialog) {
  background: var(--bg-card);
  border: 1px solid var(--border);
}
.dark-dialog :deep(.el-dialog__title) {
  color: #fff;
}
.dark-dialog :deep(.el-form-item label) {
  color: var(--text-sub);
}
.detail-wrap {
  display: flex;
  flex-direction: column;
  gap: 24px;
  color: var(--text-sub);
}
.block-title {
  font-size: 16px;
  color: #fff;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 12px;
}
.info-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}
.info-item {
  display: flex;
  gap: 6px;
}
.info-item label {
  color: #94b8d9;
  white-space: nowrap;
}
.info-long p {
  margin: 8px 0;
  line-height: 1.6;
}
.info-long label {
  color: #94b8d9;
  margin-right: 6px;
}
</style>
